import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {TariffBase} from '../../../domain/tariff-base';
import {SupplyType, TariffEntity} from '../../../domain/tariff-entity';
import {TariffService} from '../../../services/tariff.service';
import {BillCalcService} from '../../../services/billcalc.service';
import {BillingPeriod} from '../../../domain/billing-period';
import {forkJoin, of} from 'rxjs';
import {catchError, map, take} from 'rxjs/operators';
import {ChargesWithBillingPeriod} from '../../../domain/charges-with-billing-period';

@Component({
  selector: 'app-tariff-billing',
  templateUrl: './tariff-billing.component.html',
  styleUrls: ['./tariff-billing.component.css']
})

export class TariffBillingComponent implements OnInit, OnChanges {
  @Input() tariff: TariffBase;

  loading: boolean;
  tariffDropdownListings: TariffEntity[];
  file: any;
  billingPeriods: Array<BillingPeriod>;
  charges: Array<ChargesWithBillingPeriod>;
  supplyCode: string;
  fileError: boolean;
  runError: boolean;

  constructor(
    private tariffService: TariffService,
    private billCalcService: BillCalcService) {
  }

  ngOnInit() {
    this.tariffService.getTariffs(SupplyType).subscribe(data => {
      this.tariffDropdownListings = data;
      this.tariffDropdownListings.sort((a, b) =>
        (a.code > b.code) ? 1 : ((b.code > a.code) ? -1 : 0)
      );
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.charges = undefined;
  }

  onChooseFile(event: any) {
    this.fileError = undefined;
    this.charges = undefined;
    this.billingPeriods = [];
    this.loading = true;

    this.file = event.target.files[0];
    this.billCalcService.getBillingPeriods(this.file).subscribe(data => {
      this.billingPeriods = data;
      this.loading = false;
    }, (error => {
      console.log(error);
      this.fileError = true;
      this.loading = false;
    }));
  }

  onRun() {
    this.runError = undefined;
    this.charges = new Array<ChargesWithBillingPeriod>();
    this.loading = true;

    // map to run a bill calc for each bill period
    const billCalcs$ = this.billingPeriods.map(bp => {
      const startDate = bp.startDate;
      const endDate = bp.endDate;
      const deliveryCode = this.tariff.code;
      const supplyCode = this.supplyCode;
      // get observable for run op for a given bill period
      return this.billCalcService.runBillCalc(startDate, endDate, deliveryCode, supplyCode, this.file);
    });
    forkJoin(billCalcs$).pipe(
      take(1),
      // return a run bill calc result for each
      map(charges => {
        // sort the results by bill period
        charges.sort((a, b) => a.startDate.localeCompare(b.startDate));
        return charges;
      }),
      catchError(err => {
        console.log(err);
        this.runError = true;
        this.loading = false;
        return of(err);
      })
    ).subscribe(charges => {
      // record bill charges as they async return from each calculation
      this.charges = charges;
      this.loading = false;
    });
  }

  setTariffSelection(value: any) {
    this.supplyCode = value;
  }
}
